import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Menus from "../Menus";
import { BlankString, LogoUrl, ApplicationName, MenuId } from "../Constants";
import { useDispatch, RootStateOrAny, useSelector } from "react-redux";
import { ActionTypes } from "../redux/ActionTypes";
import { AuthenticationConstans } from "../Constants";
import { GetStorageItem, ClearStorage, SetMenuRestoredStatus, GetMenuRestoredStatus } from "../helpers/Functions";
import { GetUserRoles } from "../helpers/Functions";
import IMenu from "../components/pages/models/interfaces/IMenu";

declare global {
  interface Window {
    ToggleMenu: () => void;
    SetMenuArrowIcon: () => void;
  }
};

export default function MenuBar() {
  const userIdentity = GetStorageItem(AuthenticationConstans.Identity);
  const [linkToHome] = useState("/");
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let routeLinkName: string = location.pathname.substring(1);
  if (routeLinkName.length == 0) { routeLinkName = "Home" };
  let activeLinkName = useSelector((state: RootStateOrAny) => state.portalData.activeLink);
  let activeFirstLevelSubMenu = useSelector((state: RootStateOrAny) => state.portalData.activeFirstLevelSubMenu);
  if (activeLinkName === BlankString) { activeLinkName = routeLinkName; }
  const ToggleMobileMenu = (submenu: any, activeLink: number, firstlevelSubMenu: number) => {
    if (activeLink !== activeLinkName)
      dispatch({ type: ActionTypes.SET_ACTIVE_LINK, payload: 0 });
    if (activeFirstLevelSubMenu !== firstlevelSubMenu)
      dispatch({ type: ActionTypes.SET_FIRST_LEVEL_ACTIVE_MENU, payload: 0 });
    if (submenu === undefined) window.ToggleMenu();
  };
  useEffect(() => {
    const menuRestored = GetMenuRestoredStatus();
    if (menuRestored === false && userIdentity) {
      window.SetMenuArrowIcon();
      SetMenuRestoredStatus(true);
    }
  });
  return (
    <div id="header" className="header bg-color">
      <div className="container">
        <div className="row">
          <div className="header-wrap">
            <div className="col-md-2">
              <div id="logo" className="logo">
                <Link to={linkToHome}
                  onClick={() => {
                    dispatch({ type: ActionTypes.SET_ACTIVE_LINK, payload: MenuId.DASHBOARD });
                    dispatch({ type: ActionTypes.SET_FIRST_LEVEL_ACTIVE_MENU, payload: 0 });
                  }}>
                  <img src={LogoUrl} alt={ApplicationName} />
                </Link>
              </div>
            </div>
            <div className="col-md-10">
              <div className="nav-wrap">
                <div className="btn-menu">
                  <span></span>
                </div>
                <nav id="mainnav" className="mainnav">
                  <ul className="menu">
                    {
                      Menus.map((data: IMenu) => {
                        const hasAccess = data.allowedRoles !== undefined ? data.allowedRoles!.some(role => GetUserRoles().includes(role)) : true;
                        if (((data.secure === true) && (userIdentity === null)) || (userIdentity !== null && data.name === "Login")) { return null; }
                        if (!hasAccess || !data.show) return;
                        return (
                          <li key={data.id}>
                            <Link
                              key={`link-${data.id}`}
                              onClick={() => ToggleMobileMenu(data.submenu, data.id, data.defaultSubmenuId)}
                              to={data.linkmenu}
                              className={activeLinkName === data.id ? "active" : BlankString}>{data.name}
                              <span className="hidden-sm hidden-xs">
                                <i className={data.submenu === undefined ? BlankString : "fa fa-angle-down"} aria-hidden="true"></i>
                              </span>
                            </Link>
                            {
                              data.submenu === undefined ? BlankString :
                              <ul className="sub-menu" key={`sub-menu-${data.id}`}>
                                {
                                  data.namesub.map((submenu: IMenu) => {
                                    const hasAccess = submenu.allowedRoles !== undefined ? submenu.allowedRoles!.some((role: any) => GetUserRoles().includes(role)) : true;
                                    if (!hasAccess) return;
                                    return (
                                      <li
                                        key={submenu.id}
                                        className={activeFirstLevelSubMenu === submenu.id ? "active" : BlankString}>
                                        <Link
                                          key={`link-${submenu.id}`}
                                          onClick={() => ToggleMobileMenu(submenu.submenu, data.id, submenu.id)}
                                          to={submenu.linkmenu}>{submenu.name}
                                        </Link>
                                      </li>
                                    )
                                  })
                                }
                              </ul>
                            }
                          </li>
                        );
                      })
                    }
                    {
                      (userIdentity !== null && userIdentity !== BlankString ? <li onClick={() => {
                        ClearStorage();
                        dispatch({ type: ActionTypes.SET_IDENTITY_NAME, payload: null });
                        dispatch({ type: ActionTypes.SET_FIRST_LEVEL_ACTIVE_MENU, payload: 0 });
                        window.ToggleMenu();
                        navigate("/Login");
                      }}><Link to="#" className={activeLinkName === "Logout" ? "active" : BlankString}>Logout</Link></li> : null)
                    }
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};